import { Axios } from 'utils/AxiosConfig'

export const getAdvisors = async (payload) => {
  const { data: response } = await Axios.get(`public/filter/advisor`, payload)
  return response
}
export const getAdvisorsRandom = async (payload) => {
  const { data: response } = await Axios.get(`public/filter/advisor`, payload)
  return response
}
export const getAdvisorDetail = async (payload) => {
  const { data: response } = await Axios.get(`public/filter/advisor/${payload.id}`)
  return response
}

export const postProfileAdvisor = async (payload) => {
  const { data: response } = await Axios.post(`member/package-subscription/advisor`, payload)
  return response
}

export const putProfileAdvisor = async (payload) => {
  const { data: response } = await Axios.put(`member/profile/advisor/update-profile`, payload)
  return response
}
